import { Menu, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import {
  UserOutlined,
  BankOutlined,
  FlagOutlined,
  HomeOutlined,
  ClockCircleFilled,
  SyncOutlined,
  FileSearchOutlined,
  DashboardOutlined,
  LineChartOutlined,
  SettingOutlined,
  CalendarOutlined,
  RobotOutlined,
} from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";
import SwitchPerfCycleModal from "../modal/SwitchPerfCycleModal";
import { useSelector } from "react-redux";
import moment from "moment";
import { getPluralString } from "../../helpers/wordHelpers";
import { usePermissions } from "../../hooks/usePermissions";
import Theme from "../../theme/Theme";

const paths = [
  { path: "/home", key: "1" },
  { path: "/my-plans", key: "2" },
  { path: "/timeline", key: "3" },
  { path: "/timesheets", key: "10" },
  { path: "/units", key: "4" },
  { path: "/top-plans", key: "5" },
  { path: "/positions-performance", key: "6" },
  { path: "/individual-perf", key: "7" },
  { path: "/metabase", key: "8" },
  { path: "/prediction", key: "9" },
  { path: "/gem", key: "11" },
];

function DashboardSideMenu(props) {
  const proHeight = document.body.clientHeight;
  const [mainKey, setMainKey] = useState("");
  const [switchModal, setSwitchModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const topPlanState = useSelector((state) => state.topPlanState.value);
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const { hasTimelinePermission, hasPredictionPermission, hasTimesheetPermission, hasGemPermission } = usePermissions();
  let curLocation = useLocation();

  useEffect(() => {
    setMainKey("");
    paths.forEach((path) => {
      if (path.path === curLocation.pathname) {
        setMainKey(path.key);
      } else if (curLocation.pathname.split("/")[1] === "top-plans") {
        setMainKey("5");
      } else if (curLocation.pathname.split("/")[1] === "my-plans") {
        setMainKey("2");
      } else if (curLocation.pathname.split("/")[1] === "timeline") {
        setMainKey("3");
      } else if (curLocation.pathname.split("/")[1] === "units") {
        setMainKey("4");
      } else if (
        curLocation.pathname.split("/")[1] === "positions-performance"
      ) {
        setMainKey("6");
      } else if (
        curLocation.pathname.split("/")[1] === "prediction"
      ) {
        setMainKey("9");
      } else if (
        curLocation.pathname.split("/")[1] === "gem"
      ) {
        setMainKey("11");
      }
    });
  }, [curLocation]);

  useEffect(() => {
    if (topPlanState) {
      setLoading(false);
    }
  }, [topPlanState]);

  return (
    <>
      <style>
        {`
          .custom-menu .ant-menu-item {
            margin: 4px 8px !important;
            border-radius: 8px !important;
            transition: all 0.3s ease !important;
          }
          
          .custom-menu .ant-menu-item:hover {
            background-color: #D14A1F !important;
            color: white !important;
          }
          
          .custom-menu .ant-menu-item:hover .ant-menu-item-icon {
            color: white !important;
          }
          
          .custom-menu .ant-menu-item:hover a {
            color: white !important;
          }
          
          .custom-menu .ant-menu-item-selected {
            background-color: white !important;
            color: #D14A1F !important;
            border-radius: 8px !important;
          }
          
          .custom-menu .ant-menu-item-selected .ant-menu-item-icon {
            color: #D14A1F !important;
          }
          
          .custom-menu .ant-menu-item-selected a {
            color: #D14A1F !important;
          }
          
          .custom-menu .ant-menu-item-selected::after {
            display: none !important;
          }
          
          .custom-menu .ant-menu-item[data-menu-id="0"] {
            margin: 0 !important;
            border-radius: 0 !important;
          }
          
          .custom-menu .ant-menu-item[data-menu-id="0"]:hover {
            background-color: ${Theme().sideMenu} !important;
          }
        `}
      </style>
      <Menu
        className="transparent-scroll custom-menu"
        style={{
          height: proHeight - 64,
          overflow: "auto",
          backgroundColor: Theme().sideMenu,
          color: Theme().textPrimary,
          fontFamily: 'Inter, sans-serif',
          fontWeight: 400,
          paddingLeft: 0,
          paddingRight: 0,
        }}
        theme="light"
        selectedKeys={[mainKey]}
        mode="inline"
      >
        <Menu.Item
          key="0"
          data-menu-id="0"
          icon={
            props.collapsed && (
              <div onClick={() => setSwitchModal(true)}>
                <ClockCircleFilled style={{ color: Theme().primary }} />
              </div>
            )
          }
          style={{
            borderTop: `2px solid ${Theme().navBorder}`,
            borderBottom: `2px solid ${Theme().navBorder}`,
            marginTop: '0px',
            marginBottom: '8px',
            marginLeft: 0,
            marginRight: 0,
            paddingTop: '24px',
            paddingBottom: '24px',
          }}
        >
          <div onClick={() => setSwitchModal(true)}>
            <div className="hover:opacity-80" style={{ color: Theme().textPrimary }}>
              <div className="flex justify-between items-center">
                <div>
                  <div className="text-sm text-ellipsis overflow-hidden w-32">
                    {perfCycleState?.name || "..."}
                  </div>
                  <div className="text-xs flex items-center">
                    <div
                      className={
                        "w-2 h-2 rounded-full mr-1 " +
                        (perfCycleState?.status === "Active"
                          ? "bg-green-500"
                          : perfCycleState?.status === "Scheduled"
                          ? "bg-orange-500"
                          : "bg-blue-500")
                      }
                    />
                    {perfCycleState?.name
                      ? moment(perfCycleState?.startingOn).format("DD.MM.YY") +
                        " - " +
                        moment(perfCycleState?.endingOn).format("DD.MM.YY")
                      : "..."}
                  </div>
                </div>
                <Tooltip title={"Change cycle"}>
                  <div style={{ color: Theme().primary }} className="hover:opacity-80">
                    <SyncOutlined />
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>
        </Menu.Item>
        <Menu.Item key="1" icon={<HomeOutlined />}>
          <Link to="/home">Home</Link>
        </Menu.Item>
        <Menu.Item key="8" icon={<DashboardOutlined />}>
          <Link to="/metabase">Dashboard</Link>
        </Menu.Item>
        <Menu.Item key="2" icon={<FileSearchOutlined />}>
          <Link to="/my-plans">My Plans</Link>
        </Menu.Item>
        {hasTimelinePermission && (
          <Menu.Item key="3" icon={<CalendarOutlined />}>
            <Link to="/timeline">Timeline</Link>
          </Menu.Item>
        )}
        {hasTimesheetPermission && (
          <Menu.Item key="10" icon={<ClockCircleFilled />}>
            <Link to="/timesheets">Timesheets</Link>
          </Menu.Item>
        )}
        <div
          className={
            "text-xs mt-3 mb-3" +
            (props.collapsed ? " text-center" : " pl-6")
          }
          style={{ color: Theme().textPrimary }}
        >
          perf
          <span style={{ display: props.collapsed ? "none" : "inline" }}>
            ormance
          </span>
        </div>
        <Menu.Item key="5" icon={<FlagOutlined />}>
          <Link to="/top-plans">
            {loading ? "..." : getPluralString(topPlanState) || "Top plans"}
          </Link>
        </Menu.Item>
        <Menu.Item key="4" icon={<BankOutlined />}>
          <Link to="/units">Units</Link>
        </Menu.Item>
        <Menu.Item key="6" icon={<UserOutlined />}>
          <Link to="/positions-performance">Positions</Link>
        </Menu.Item>
        {hasPredictionPermission && (
          <Menu.Item key="9" icon={<LineChartOutlined />}>
            <Link to="/prediction">Prediction</Link>
          </Menu.Item>
        )}
        {hasGemPermission && (
          <Menu.Item key="11" icon={<RobotOutlined />}>
            <Link to="/gem">GEM</Link>
          </Menu.Item>
        )}
        {/* Removed standalone settings label under Prediction as requested */}
      </Menu>
      <SwitchPerfCycleModal
        visible={switchModal}
        handleCancel={() => setSwitchModal(false)}
      />
    </>
  );
}

export default DashboardSideMenu;
